import { render, staticRenderFns } from "./bsp-image-preview.vue?vue&type=template&id=2c131d5a&"
import script from "./bsp-image-preview.vue?vue&type=script&lang=js&"
export * from "./bsp-image-preview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports